'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Validate limits for compliance
 */
var validate = function validate(_ref) {
  var _common, _sga, _dga, _es;

  var normalizedLimits = _ref.normalizedLimits,
      jurisdiction = _ref.jurisdiction,
      _ref$limitIncreaseInf = _ref.limitIncreaseInfo,
      limitIncreaseInfo = _ref$limitIncreaseInf === undefined ? {} : _ref$limitIncreaseInf,
      type = _ref.type,
      timespan = _ref.timespan;

  jurisdiction = (jurisdiction || '').toLowerCase();

  var timespans = Object.values((0, _get2.default)(normalizedLimits, '[' + type + '].timespans', []));
  timespan = (0, _get2.default)(normalizedLimits, '[' + type + '].timespans[' + timespan + ']');

  var limitCount = timespans.filter(function (t) {
    return t.newLimit ? t.newLimit.Amount > 0 : (0, _get2.default)(t, 'currentLimit.Amount') && (!t.pendingDeleteLimit || t.pendingActivateLimit);
  }).length;
  var isIncreasingLimit = timespans.some(function (t) {
    return (0, _get2.default)(t, 'newLimit.Amount') > (0, _get2.default)(t, 'currentLimit.Amount');
  });
  // Per transaction (0) limits are depricated, hence these are allowed to be removed.
  var isRemovingLimit = timespans.filter(function (t) {
    return t > 0;
  }).some(function (t) {
    return (0, _get2.default)(t, 'newLimit.Amount') === 0;
  });
  var limitsArePristine = Object.values(timespans).every(function (t) {
    return !t.newLimit || (0, _get2.default)(t, 'newLimit.Amount') === (0, _get2.default)(t, 'currentLimit.Amount');
  });

  var newMonthlyDepositLimit = timespans.find(function (t) {
    return (0, _get2.default)(t, 'newLimit.Type') === 'Deposit' && t.timespan === 30;
  });

  /**
   * Compose jurisdictions with rules
   */
  var common = (_common = {}, _defineProperty(_common, 'show-confirm-on-submit', type === 'Block' || type === 'SelfExclude'), _defineProperty(_common, 'insufficient-limit-count', false), _defineProperty(_common, 'limits-are-pristine', limitsArePristine), _defineProperty(_common, 'limit-increase-blocked', false), _defineProperty(_common, 'limit-remove-blocked', false), _defineProperty(_common, 'isValid', function isValid() {
    return !this['insufficient-limit-count'] && !(this['limit-increase-blocked'] && isIncreasingLimit) && !(this['limit-remove-blocked'] && isRemovingLimit);
  }), _common);
  var mga = {};
  var sga = (_sga = {}, _defineProperty(_sga, 'insufficient-limit-count', type === 'Deposit' && limitCount < 3), _defineProperty(_sga, 'limit-remove-blocked', type === 'Deposit'), _defineProperty(_sga, 'monthly-deposit-above-10k', (0, _get2.default)(newMonthlyDepositLimit, 'newLimit.Amount') >= 10000), _sga);
  var uk = {};
  var dga = (_dga = {}, _defineProperty(_dga, 'insufficient-limit-count', type === 'Deposit' && limitCount < 1), _defineProperty(_dga, 'limit-remove-blocked', type === 'Deposit' && limitCount <= 1), _dga);
  var es = (_es = {}, _defineProperty(_es, 'insufficient-limit-count', type === 'Deposit' && limitCount < 3), _defineProperty(_es, 'limit-remove-blocked', type === 'Deposit'), _defineProperty(_es, 'limit-increase-blocked', type === 'Deposit' && limitIncreaseInfo.HasDepositLimitIncreaseBlock), _defineProperty(_es, 'support-pending', type === 'Deposit' && limitIncreaseInfo.HasValidPgsiScore && limitIncreaseInfo.RequiresSupportApproval), _defineProperty(_es, 'requires-self-test', isIncreasingLimit && type === 'Deposit' && !limitIncreaseInfo.HasDepositLimitIncreaseBlock), _defineProperty(_es, 'self-test-fail-cooldown', type === 'Deposit' && !limitIncreaseInfo.HasValidPgsiScore && limitIncreaseInfo.HasDepositLimitIncreaseBlock), _es);

  switch (jurisdiction) {
    case 'mga':
      return _extends({}, common, mga);
    case 'uk':
      return _extends({}, common, uk);
    case 'dga':
      return _extends({}, common, dga);
    case 'sga':
      return _extends({}, common, sga);
    case 'es':
      return _extends({}, common, es);
    default:
      {
        return common;
      }
  }
};

exports.default = validate;